type WithLocaleString = (value: number) => string;

export const withLocaleString: WithLocaleString = (value) =>
  value.toLocaleString();
